import { render, staticRenderFns } from "./smsLog.vue?vue&type=template&id=5f5357be&scoped=true"
import script from "./smsLog.vue?vue&type=script&lang=ts"
export * from "./smsLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5357be",
  null
  
)

export default component.exports